// extracted by mini-css-extract-plugin
module.exports = {"video-player":"styles_video-player__3KM6C"};